module.exports = __webpack_public_path__ + "70ee8a2184ce451d4d4b65fa16685d66.pdf";